<div class="grid-wrapper">
  <div class="grid-toolbar">
    <button class="btn btn-primary" type="button" (click)="onCreate()">Create</button>
  </div>
  @if (loading) {
    <div class="grid-loading">Loading…</div>
  }
  @if (error) {
    <div class="grid-error">{{ error }}</div>
  }
  @if (!loading && rows && rows.length) {
    <table class="grid-table table table-dark">
      <thead>
        <tr>
          @if (showActions) {
            <th>Actions</th>
          }
          @for (col of derivedColumns; track col) {
            <th>{{ col }}</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of rows; track row) {
          <tr>
            @if (showActions) {
              <td class="grid-actions">
                <button type="button" class="icon-btn edit" (click)="onEdit(row)" title="Edit" aria-label="Edit">
                  <span class="icon-pencil text-white"></span>
                </button>
                <button type="button" class="icon-btn delete" (click)="onDelete(row)" title="Delete"
                  aria-label="Delete">
                  <span class="icon-bin text-white"></span>
                </button>
              </td>
            }
            @for (col of derivedColumns; track col) {
              <td>{{ displayValue(row[col]) }}</td>
            }
          </tr>
        }
      </tbody>
    </table>
  } @else {
    <div class="grid-empty">No items</div>
  }

</div>